// @flow

import {HorizontalPositionElement} from './constants';

import type {HorizontalPositionElementType} from './typedef';


type GetOffsetLeft = (
    width: number,
    horizontal: HorizontalPositionElementType,
    isFlip: boolean,
) => number;

/**
* Utility that calculates the horizontal offset.
* @param {number} width - Container width.
* @param {HorizontalPositionElementType} horizontal - To which point horizontally is the position attached.
* @param {boolean} isFlip - Is the container inverted.
* @returns {number}
 @deprecated It will be removed in 6 months 04-28-2026. Use Floating instead.
*/
export const getOffsetLeft: GetOffsetLeft = (width, horizontal, isFlip) => {
    let offset = 0;

    if (typeof horizontal === 'number') {
        offset = horizontal;
    } else if (horizontal === HorizontalPositionElement.CENTER) {
        offset = width / 2;
    } else if (horizontal === HorizontalPositionElement.RIGHT && !isFlip) {
        offset = width;
    } else if (horizontal === HorizontalPositionElement.LEFT && isFlip) {
        offset = width;
    }

    return offset;
};


            // @pb/generate-flow-typed Webpack Loader:
            // Duplicates all internal dependencies imports
            // to be sure all deps are parsed by this loader
            // cause Babel loader removes `import type ...`
            // and e.g. 'typedef.js' files are not included in dist
            
require("./typedef");
